/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


var tab_switch_contents = $(".tab-switch__content");
var tab_switch_navs = $('.tab-switch__nav li');
$(document).ready(
    function() {
        $('.tab-switch__nav li').on('click', function(e) {
            e.preventDefault();
            tab_switch_contents.addClass("hide");
            var content_tab = $(this).children("span").attr("id");
            $(content_tab).removeClass("hide");
            tab_switch_navs.removeClass("active");
            $(this).addClass("active");
          	console.log(content_tab);
        });
        $('.designer-trigger li').on('click', function () {
            var text = $(this).text().toUpperCase();
            if (text == "ALL") {
                $('.alphabet-title').removeClass('hide');
            }
            else {
                $('.alphabet-title').addClass('hide');
                $('.alphabet_'+text).removeClass('hide');
            }
        });
        $("#AccountTrigger").on('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            $("#account-tab").toggle();
            console.log("here");
        });
    }
);

$('.projectify-header-trigger').mouseenter(
    function () {
        var content = $(this).children('span').attr("id");
        $('.projectify-header-trigger').removeClass("active");
        $(this).addClass("active");
        var right_sections = $('.projectify-header__right-section-menuitem');
        right_sections.addClass("hide");
        $(content).removeClass("hide");
    }
);